module.exports = __webpack_public_path__ + "static/media/fyntiq.8ea7f0a5.png";